import loadable from '@loadable/component';

export const AsyncAATestModule = loadable(
    () =>
        import(
            /* webpackChunkName: "AA-test" */
            /* webpackPrefetch: true */
            './AATest'
        ),
    {ssr: false}
);

AsyncAATestModule.displayName = 'AsyncAATestModule';
